const articleConfig = {
  label: "ActionJournal",
  resourceEndpoint: "journals",
  listMetadata: [
    "sort_order",
    "title",
    "featured",
    "topics",
    "categories",
    "release_date",
    "tags",
    "actions",
  ],
  keepListMetadataOrder: true,
  searchKeys: ["title", "description"],
  detailsMetadata: [
    {
      name: "title",
      label: "Title",
      validations: [{ type: "max", params: [70, "Maximum 70 Characters"] }],
    },
    { name: "description", label: "Description" },
    { name: "audio_url", label: "Audio URL" },
    { name: "image_url", label: "Image URL" },
    {
      name: "question_1",
      label: "Journal 1",
      validations: [{ type: "required", params: ["Required"] }],
    },
    { name: "question_2", label: "Journal 2" },
    { name: "question_3", label: "Journal 3" },
    { name: "question_4", label: "Journal 4" },
    { name: "question_5", label: "Journal 5" },
    { name: "release_date", label: "Release Date" },
    {
      name: "cta_type",
      label: ""
    },
    {
      name: "action_bar_text",
      label: "Call to Action Text",
      conditions: [
        {
          relativeField: "cta_type",
          comparisonFunc: (relativeField, _thisField) => {
            return !["Preset CTA", "Launch Business"].includes(relativeField.value);
          },
        },
      ],
    },
    {
      name: "action_bar_text_enterprise",
      label: "Launch Business Call to Action Text",
      conditions: [
        {
          relativeField: "cta_type",
          comparisonFunc: (relativeField, _thisField, setup) => {
            return relativeField.value === "Launch Business" && setup?.enterprise_launch_business;
          },
        },
      ],
    },
    {
      name: "action_bar_url",
      label: "Call to Action URL",
      conditions: [
        {
          relativeField: "cta_type",
          comparisonFunc: (relativeField, _thisField) => {
            return !["Preset CTA", "Launch Business"].includes(relativeField.value);
          },
        },
      ],
    },
    {
      name: "enterprise_app",
      label: "Which Business?",
      conditions: [
        {
          relativeField: "cta_type",
          comparisonFunc: (relativeField, _thisField, setup) => {
            return relativeField.value === "Launch Business" && setup?.enterprise_launch_business;
          },
        },
      ],
    },
    {
      name: "cta",
      label: "Call to Action Name List",
      conditions: [
        {
          relativeField: "cta_type",
          comparisonFunc: (relativeField, _thisField) => {
            return relativeField.value === "Preset CTA";
          },
        },
      ],
    },
    { name: "sort_order", label: "Sort Order" },
    { name: "featured", label: "Featured?" },
    { name: "topics", label: "Topics/Listings" },
    { name: "categories", label: "Categories" },
    { name: "tags", label: "Tags" },
  ],
  formLayout: {
    columns: [
      [
        "title",
        "image_url",
        "audio_url",
        "description",
        "question_1",
        "question_2",
        "question_3",
        "question_4",
        "question_5",
      ],
      [
        "release_date",
        "cta_type",
        "action_bar_text",
        "action_bar_text_enterprise",
        "action_bar_url",
        "enterprise_app",
        "cta",
        "featured",
        "topics",
        "categories",
        "sort_order",
        "tags",
      ],
    ],
  },
};

export default articleConfig;
